var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _c(
      "div",
      { staticClass: "login-card" },
      [
        _c("img", {
          staticClass: "logo",
          attrs: { src: _vm.logo_url, alt: "company-logo" }
        }),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.label_login))]),
        _vm._v(" "),
        _c("p", [_vm._v("Login into your account")]),
        _vm._v(" "),
        _c(
          "b-form",
          {
            on: {
              reset: _vm.onReset,
              keyup: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key)
                ) {
                  return null
                }
                _vm.onSubmit($event)
              }
            }
          },
          [
            _c(
              "b-form-group",
              [
                _c("b-form-input", {
                  class: { "error-input": _vm.$v.form.username.$error },
                  attrs: {
                    "error-message": null,
                    placeholder: "Username",
                    type: "text"
                  },
                  model: {
                    value: _vm.$v.form.username.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.form.username, "$model", $$v)
                    },
                    expression: "$v.form.username.$model"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { id: "loginPasswordInputLdap" } },
              [
                _c("b-form-input", {
                  class: { "error-input": _vm.$v.form.password.$error },
                  attrs: {
                    type: _vm.password_id,
                    "error-message": null,
                    placeholder: "Password"
                  },
                  model: {
                    value: _vm.$v.form.password.$model,
                    callback: function($$v) {
                      _vm.$set(_vm.$v.form.password, "$model", $$v)
                    },
                    expression: "$v.form.password.$model"
                  }
                }),
                _vm._v(" "),
                _c("label", [
                  _c("i", {
                    class: {
                      "fa fa-eye": !_vm.show_pass,
                      "fa fa-eye-slash": _vm.show_pass
                    },
                    attrs: { role: "img" },
                    on: {
                      click: function($event) {
                        _vm.show_pass = !_vm.show_pass
                      }
                    }
                  })
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn-login",
                class: { disabled: _vm.$v.form.$invalid },
                attrs: { disabled: _vm.$v.form.$invalid },
                on: { click: _vm.onSubmit }
              },
              [_vm._v("\n        Login\n      ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("img", {
          staticClass: "logo-oos",
          attrs: { src: require("@/assets/logo/logo_oos.png"), alt: "oos-logo" }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-099545e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-099545e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/jLoginLdap.vue
// module id = null
// module chunks = 